module.exports = __webpack_public_path__ + "media/images/athletes/1650-a3d5c231529225f4926f079b73d22846.png";